import {inject, Injectable, Injector, runInInjectionContext} from '@angular/core';
import {OuraApiResponseIntf, OuraHeartIntf, OuraSleepIntf}   from '@djsharkk/logr-types';
import {DateTime}                                            from 'luxon';
import {BehaviorSubject}                                     from 'rxjs';
import {FirebaseToolsService}                                from '../../firebase/firebase-tools.service';
import {DataFactoryBase}                                     from '../data-factory.base';
import {DataFilterService}                                   from '../data-filter.service';
import {ProcessHeartData, ProcessSleepData}                  from './data-oura.processors';

@Injectable({
				providedIn: 'root'
			})
export class DataOuraService extends DataFactoryBase {
	injector = inject(Injector)
	public svcFireTools = inject(FirebaseToolsService);
	public svcDataFilters = inject(DataFilterService);

	recordsOuraSleep = new BehaviorSubject<OuraSleepIntf[]>([]);
	recordsOuraHeart = new BehaviorSubject<OuraHeartIntf[]>([]);

	async initializeData(start: Date = this.svcDataFilters.dateStart, end: Date = this.svcDataFilters.dateEnd) {
		await runInInjectionContext(this.injector, async () => {
			const sleepRecords = await this.svcFireTools.getOuraApi<OuraApiResponseIntf<OuraSleepIntf>>('getSleep', start, end)
			const sleepRecordsProcessed = ProcessSleepData(sleepRecords.data.data).sort((a, b) => a.day.getTime() < b.day.getTime() ? 1 : -1);
			this.updateSleepData(sleepRecordsProcessed);
			this.recordsOuraSleep.next(sleepRecordsProcessed);
		});
		await runInInjectionContext(this.injector, async () => {
			const heartRecords = await this.svcFireTools.getOuraApi<OuraApiResponseIntf<OuraHeartIntf>>('getHeart', start, end)
			this.recordsOuraHeart.next(ProcessHeartData(heartRecords.data.data));
		});
	}

	updateSleepData(data: OuraSleepIntf[]): void {
		for (let i = 0; i < data.length; i++) {
			const currentEntry = data[i];
			const previousEntry = data[i - 1] || null;

			const dayStart = DateTime.fromJSDate(currentEntry.day).startOf('day').toJSDate();
			const dayEnd = DateTime.fromJSDate(currentEntry.day).endOf('day').toJSDate();

			const bedtimeStart = currentEntry.bedtime_start as Date;
			const bedtimeEnd = currentEntry.bedtime_end as Date;

			if (bedtimeStart < dayStart && bedtimeEnd < dayStart) {
				console.info('Oura data does not overlap with the current day:', currentEntry);
				continue; // Skip processing this entry
			}

			// Calculate adjustedBedtimeStart
			currentEntry.adjustedBedtimeStart = bedtimeStart < dayStart ? dayStart : bedtimeStart;

			// Initialize nextBedtimeStart and nextBedtimeEnd
			let nextBedtimeStart: Date | undefined = undefined;
			let nextBedtimeEnd: Date | undefined = undefined;

			if (previousEntry) {
				const prevBedtimeStart = previousEntry.bedtime_start as Date;
				const prevBedtimeEnd = previousEntry.bedtime_end as Date;

				// Calculate nextBedtimeStart if it falls within the current day
				if (prevBedtimeStart >= dayStart && prevBedtimeStart <= dayEnd) {
					nextBedtimeStart = prevBedtimeStart;
				}

				// Calculate nextBedtimeEnd
				if (prevBedtimeEnd > dayEnd) {
					nextBedtimeEnd = dayEnd; // Trim to end of the day
				} else if (prevBedtimeEnd >= dayStart) {
					nextBedtimeEnd = prevBedtimeEnd; // Keep as is if within bounds
				}
			}

			// Assign the calculated values back to the current entry
			currentEntry.nextBedtimeStart = nextBedtimeStart;
			currentEntry.nextBedtimeEnd = nextBedtimeEnd;
		}
	}


	/*updateSleepData(data: OuraSleepIntf[]): void {
	 // Iterate through the data array
	 data.forEach((currentEntry, index) => {
	 const bedtimeStart = DateTime.fromJSDate(currentEntry.bedtime_start); // Start of sleep
	 const bedtimeEnd = DateTime.fromJSDate(currentEntry.bedtime_end); // End of sleep
	 const recordDay = DateTime.fromJSDate(currentEntry.day).startOf('day'); // Start of the recorded day

	 // 1. Calculate `adjustedBedtimeStart`
	 // Adjusts the portion of sleep that falls within the current day
	 if (bedtimeStart < recordDay) {
	 currentEntry.adjustedBedtimeStart = recordDay.toJSDate(); // Midnight of the recorded day
	 } else {
	 currentEntry.adjustedBedtimeStart = bedtimeStart.toJSDate(); // As is, if already on the recorded day
	 }

	 // 2. Calculate `nextBedtimeEnd`
	 // Adds an end property to the previous day's entry for the portion of sleep before midnight
	 const previousEntry = data[index - 1] || null; // Get the previous entry, if it exists

	 if (previousEntry) {
	 const prevBedtimeStart = DateTime.fromJSDate(previousEntry.bedtime_start); // Start of the previous entry’s sleep
	 const prevDayEnd = prevBedtimeStart.startOf('day').plus({hours: 24}); // Midnight of the day of `bedtime_start`

	 if (prevBedtimeStart < recordDay) {
	 // Add `nextBedtimeEnd` for the portion of sleep before midnight
	 previousEntry.nextBedtimeEnd = prevDayEnd.toJSDate();
	 }
	 }
	 });
	 }*/


}
